import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { useEventsController } from "../hooks/useEventsController";
import SearchBox from "../components/SearchBox";
import EventsGrid from "../components/EventsGrid";
import ClipPlayer from "../components/ClipPlayer";
export default function MainView() {
    const { user } = useAuth();
    const { events, unreachable, selected, setSelected, loading, error, searchedFor, loadDefault, search, availableCameras, } = useEventsController();
    useEffect(() => {
        if (user)
            loadDefault();
    }, [user, loadDefault]);
    return (_jsxs("div", { className: "main-view", children: [_jsx(SearchBox, { onSearch: search, busy: loading, availableCameras: availableCameras }), searchedFor && (_jsxs("div", { className: "search-summary", children: ["Showing matches for ", _jsx("strong", { children: searchedFor }), ".", " ", _jsx("button", { className: "link-button", onClick: () => loadDefault(), children: "back to recent" })] })), error && _jsx("div", { className: "error-banner", children: error }), _jsx(EventsGrid, { events: events, unreachable: unreachable, onPlay: (ev) => setSelected(ev), emptyText: searchedFor ? "No matches." : "No recent events." }), _jsx(ClipPlayer, { ev: selected, onClose: () => setSelected(null) })] }));
}
